import { createFileRoute } from '@tanstack/react-router';
import { SignIn } from '@clerk/react';
import { ClerkScope } from '../auth/ClerkScope';
import { AuthLayout } from '../pages/auth/AuthLayout';
import { authFormAppearance } from '../pages/auth/authFormAppearance';
import { m } from '../paraglide/messages';

/**
 * Our own sign-in page, replacing the modal the nav used to open. `ssr: false`
 * because the whole page is Clerk, which is client-only - there is no markup
 * worth prerendering and no hydration boundary to keep identical.
 */
export const Route = createFileRoute('/sign-in')({
  ssr: false,
  // Without this the page inherits the root default and serves the homepage's
  // title, which is crawlable here: neither auth route is in the sitemap but
  // neither is disallowed either.
  head: () => ({ meta: [{ title: m.app_sign_in_title() }] }),
  component: SignInRoute,
});

function SignInRoute() {
  return (
    <ClerkScope>
      <AuthLayout title={m.app_sign_in_heading()}>
        <SignIn appearance={authFormAppearance} />
      </AuthLayout>
    </ClerkScope>
  );
}
